<template>
  <div class="btn-container">
    <!-- <div class="btn" @click="goHome">{{getText}}</div> -->
    <rich-button 
      v-if="status === 2" 
      @click.native="goHome()"
    >
      {{ $t("FoodC_C_Go_VWzj") }}
    </rich-button>
     <!-- 支付时显示气泡 -->
    <div v-if="status === 1" class="bubble">
      <Bubble :bubbleContent="bubbleContent"/>
    </div>
    <rich-button
      v-if="status === 1"
      :loading="loading"
      :disabled="!hasSelectedCard"
      @click.native="goHome()"
    >
      {{ $t("FoodC_C_Only_money_ZEKz", { money: priceText }) }}
    </rich-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { closePage } from '@/common/js/bridge'

import { getScheme } from '@/common/js/utils'
import { couponPayResultCk } from '@/page/newCouponsCenter/track'
import Bubble from '@/components/bubble/index.vue'

import { getBenefitsCreateV2 } from '@/api/member/index.js'
import { pullUpPayment } from '@/common/js/bridge.js'
import { PAY_STATUS } from '../../common/enumsUtil.js'

export default {
  name: 'FooterBtn',
  props: ['status', 'priceText', 'productId', 'price','bubbleContent', 'isNewVersion'],
  computed: {
    ...mapGetters(['globalParams', 'selectedCard']),
    hasSelectedCard () {
      if(this.isNewVersion) {
        return true
      }
      return Object.keys(this.selectedCard).length > 0
    },
    getBizId(){
      return this.$store.state.globalParams?.data?.bizId
    }
  },
  components:{
    Bubble
  },
  data () {
    return {
      from: 2,
      loading: false,
      queryCount: 0
    }
  },
  async created(){
    await this.getGlobalParams()
  },
  methods: {
    ...mapActions({
      createOrder: 'createOrder',
      queryOrderStatus: 'queryOrderStatus',
      getGlobalParams: 'getGlobalParams'
    }),
    goHome () {
      if (this.status === 2) {
        location.href = `${getScheme()}://soda/homePage?closeSideMenu=1`
        return
      }
      this.goPay()
    },
    async goPay () {
      if(this.isNewVersion) {
        this.payRequest(this.productId, this.price)
        return 
      }
      this.$emit('coupon-package-pay')
      const me = this
      try {
        this.loading = true
        // 创建订单
        const res = await this.createOrder({
          ...this.globalParams,
          productId: this.productId,
          price: this.price,
          payChannel: {
            cardIndex: this.selectedCard.card_index,
            channelId: this.selectedCard.channelID,
            cardOrg: this.selectedCard.card_org
          }
        })
        if (res && res.errno === 0 && res.data) {
          me.polling(async () => {
            if (me.queryCount <= 5) {
              const orderDetail = await me.queryOrderStatus({
                ...this.globalParams,
                orderId: res.data.orderId
              })
              if (orderDetail && orderDetail.errno === 0 && orderDetail.data) {
                me.queryCount += 1
                // payStatus: 0 => 待支付 1 => 已支付 2 => 已退款
                if (orderDetail.data.payStatus === 1) {
                  couponPayResultCk({
                    from: this.from,
                    result_status: 1 // 支付结果埋点，1成功、0失败
                  })
                  me.loading = false
                  // 支付成功之后弹窗提示，点击去使用关闭webview
                  me.$createDialog({
                    type: 'alert',
                    icon: 'richic-right',
                    content: me.gettext('支付成功'),
                    showClose: true,
                    confirmBtn: {
                      text: me.gettext('去预订食物'),
                      active: true,
                      disabled: false,
                      href: 'javascript:;'
                    },
                    onConfirm: () => {
                      closePage()
                    }
                  }).show()
                }
              } else {
                me.clearPolling(me.tid) // 清除轮询
                me.createErrorToast(orderDetail.errmsg)
                me.loading = false
                couponPayResultCk({
                  from: this.from,
                  result_status: 0
                })
              }
            } else {
              me.clearPolling(me.tid)
              me.createErrorToast(me.gettext('支付超时！'))
              me.loading = false
              couponPayResultCk({
                from: this.from,
                result_status: 0
              })
            }
          }, 3000)
        } else {
          me.createErrorToast(res.errmsg)
          me.loading = false
          couponPayResultCk({
            from: this.from,
            result_status: 0
          })
        }
      } catch (e) {
        me.createErrorToast()
        me.loading = false
        couponPayResultCk({
          from: this.from,
          result_status: 0
        })
      }
    },
    async payRequest(productId, price){
      // 调用创建订单
      this.loading = true
      const res = await getBenefitsCreateV2({
          productId,
          price
      })
      this.loading = false
      if(res.errno === 0) {
        // 调用金融的bridge
        const out_trade_id = res?.data?.transId
        pullUpPayment({
          out_trade_id,
          product_id:this.getBizId
        }, (res) => {
          if(res?.status === PAY_STATUS.SUCCESS) {
            // 刷新当前页面
            this.$router.go(0);
          }
        })
      } else {
          this.createErrorToast(res.errmsg || '')
      }
    },
    polling (fn, internal = 10000) {
      const me = this
      const poll = () => {
        me.tid = window.setInterval(() => {
          fn.call(me)
        }, internal)
      }
      poll()
    },
    clearPolling (tid) {
      window.clearInterval(tid)
    },
    createErrorToast (
      errmsg = '',
      defaultMsg = this.gettext('网络繁忙，请稍后再试')
    ) {
      const errorToast = this.$createToast({
        txt: errmsg || defaultMsg,
        time: 2000,
        mask: false,
        type: 'error'
      })
      errorToast.show()
    }
  },
  destroyed () {
    this.clearPolling(this.tid) // 清除轮询
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";

.btn-container {
   position: relative;
  .rich-btn {
    height: 108px;
  }
}
.bubble{
  position: absolute;
  right: 0;
  top: -4px;
}
</style>
